import { useEffect, useState } from "react";
import { API, errMsg, fmtDate } from "../../lib/api";
import { toast } from "sonner";

export default function AdminUsers() {
  const [users, setUsers] = useState(null);

  useEffect(() => {
    API.get("/admin/users").then(({ data }) => setUsers(data))
      .catch((e) => toast.error(errMsg(e)));
  }, []);

  if (!users) return <p className="py-16 text-center text-sm text-muted-foreground">Loading users…</p>;

  return (
    <div data-testid="admin-users-page">
      <h1 className="font-display text-2xl font-bold mb-6" data-testid="admin-users-title">Users ({users.length})</h1>
      <div className="bg-card border border-border rounded-lg overflow-x-auto">
        <table className="w-full text-sm" data-testid="users-table">
          <thead>
            <tr className="border-b border-border text-left text-xs tracking-[0.1em] uppercase text-muted-foreground">
              <th className="px-5 py-3 font-semibold">User</th>
              <th className="px-5 py-3 font-semibold">Joined</th>
              <th className="px-5 py-3 font-semibold">Plan</th>
              <th className="px-5 py-3 font-semibold">Status</th>
              <th className="px-5 py-3 font-semibold">Access until</th>
              <th className="px-5 py-3 font-semibold">Attempts</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {users.map((u) => (
              <tr key={u._id} data-testid={`user-row-${u.email}`}>
                <td className="px-5 py-3">
                  <p className="font-medium">{u.name}</p>
                  <p className="text-xs text-muted-foreground">{u.email}{u.role === "admin" ? " · admin" : ""}</p>
                </td>
                <td className="px-5 py-3 text-muted-foreground">{fmtDate(u.created_at)}</td>
                <td className="px-5 py-3">{u.subscription?.plan_name || "—"}</td>
                <td className="px-5 py-3">
                  {u.subscription ? (
                    <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${u.subscription.status === "active" ? "bg-success/10 text-success" : "bg-muted text-muted-foreground"}`}>
                      {u.subscription.status}
                    </span>
                  ) : <span className="text-xs text-muted-foreground">no plan</span>}
                </td>
                <td className="px-5 py-3 text-muted-foreground">{u.subscription?.end_date ? fmtDate(u.subscription.end_date) : "—"}</td>
                <td className="px-5 py-3 font-semibold">{u.attempts}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
